import {
  Activity,
  Bell,
  BriefcaseBusiness,
  Calendar,
  CreditCard,
  FileText,
  Frame,
  Home,
  type LucideIcon,
  Map as MapIcon,
  MapPin,
  MessageCircle,
  Palette,
  PieChart,
  PlugZap,
  Share2,
  ShieldCheck,
  SquareTerminal,
  Twitter,
  Users,
  Wrench,
} from 'lucide-react'

export type IconToken =
  | 'home'
  | 'terminal'
  | 'shield'
  | 'frame'
  | 'pie-chart'
  | 'map'
  | 'users'
  | 'credit-card'
  | 'file-text'
  | 'bell'
  | 'palette'
  | 'message'
  | 'share'
  | 'twitter'
  | 'activity'
  | 'calendar'
  | 'integrations'
  | 'map-pin'
  | 'wrench'
  | 'briefcase'

const ICON_MAP: Record<IconToken, LucideIcon> = {
  home: Home,
  terminal: SquareTerminal,
  shield: ShieldCheck,
  frame: Frame,
  'pie-chart': PieChart,
  map: MapIcon,
  users: Users,
  'credit-card': CreditCard,
  'file-text': FileText,
  bell: Bell,
  palette: Palette,
  message: MessageCircle,
  share: Share2,
  twitter: Twitter,
  activity: Activity,
  calendar: Calendar,
  integrations: PlugZap,
  'map-pin': MapPin,
  wrench: Wrench,
  briefcase: BriefcaseBusiness,
}

export const resolveIcon = (token?: IconToken) => {
  if (!token) return undefined
  return ICON_MAP[token]
}
